import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

export default function ViewMoreToggler({ onClickViewMore, canRenderViewMore, disableViewMore, className }) {
  return canRenderViewMore ? (
    <ButtonWithIcon
      data-e2e="view-more-toggler"
      type="link"
      sprite="ChevronRight"
      linkIconSize="xs"
      iconRight
      onClick={onClickViewMore}
      disabled={disableViewMore}
      className={`${className} e2e-view-more`}>
      View more
    </ButtonWithIcon>
  ) : null;
}

ViewMoreToggler.propTypes = {
  onClickViewMore: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableViewMore: PropTypes.bool.isRequired,
};
